import { useEffect, useState, useCallback } from "react";
import profileImg from "../../assets/images/profile.png";
import moment from "moment";
import Editor from "react-simple-wysiwyg";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import Select from "react-select";
import { useStateContext } from "../../contexts/ContextProvider";
import { leaveSessions } from "../../data";
import LeaveHistoryService from "../../services/leaveHistory.service";
import AuthService from "../../services/auth.service";
import { IoMdClose } from "react-icons/io";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Flex } from "antd";
import CommonService from "../../services/common.service";

const ApplyLeave = ({ setSuccess, leaveCat, fetchData, setHeading }) => {
  const user = AuthService.getCurrentUser();
  const { applyLeaveModal, setApplyLeaveModal, getNameInitials } = useStateContext();

  const [leaveInfo, setLeaveInfo] = useState({});

  const checkLeaveInfo = useCallback(() => {
    const payload = {
      empId: user.empid,
    };
    // console.log("Payload for Leave Info:", payload);
    if (payload.empId) {
      LeaveHistoryService.getEmpInfo(payload)
        .then((resp) => {
          if (resp.data) {
            // console.log("Leave Info:", resp.data);
            setLeaveInfo(resp.data[0]);
          }
        })
        .catch((e) => console.log(e));
    } else {
      setLeaveInfo({});
    }
  }, [user.empid]);

  useEffect(() => {
    checkLeaveInfo();
  }, [checkLeaveInfo]);

  const [approvalHierarchy, setApprovalHierarchy] = useState([
    {
      type: "TL",
      empid: "",
      name: "",
    },
    {
      type: "HR",
      empid: "",
      name: "",
    },
  ]);

  const [empList, setEmpList] = useState([]);

  const [ccList, setCCList] = useState([]);

  const fetchEmpList = useCallback(() => {
    CommonService.GetEmpList().then((resp) => {
      if (resp.data) {
        const data = resp.data.map((item) => ({
          label: item.name,
          value: item.email,
        }));
        setEmpList(data);
      }
    });
  }, []);

  const fetchApprovalHierarchy = () => {
    const req1 = {
      userId: user.empid,
    };

    LeaveHistoryService.getTeamLeadDetail(req1)
      .then((response) => {
        if (response.data) {
          const data = [...approvalHierarchy];
          data[0].empid = response.data.empid;
          data[0].name = response.data.name;
          setApprovalHierarchy(data);
        }
      })
      .catch((e) => console.log(e));

    const req2 = {
      Empid: user.empid,
    };

    LeaveHistoryService.getHRDetail(req2)
      .then((response) => {
        if (response.data) {
          const data = [...approvalHierarchy];
          data[1].empid = response.data.empid;
          data[1].name = response.data.name;
          setApprovalHierarchy(data);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (applyLeaveModal) {
      fetchApprovalHierarchy();
    }
  }, [applyLeaveModal]);

  useEffect(() => {
    fetchEmpList();
  }, [fetchEmpList]);

  const [fromDate, setFromdate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dor, setDOR] = useState("");

  const [loading, setLoading] = useState(false);

  const initialData = {
    leaveCategory: "",
    leaveReason: "",
    fromDate: "",
    formatedFromDate: "",
    fromDateSession: "0",
    toDate: "",
    formatedToDate: "",
    toDateSession: "0",
    duration: "0",
    remark: ``,
    dor: "",
    formatedDOR: "",
    ccList: []
  };

  const [details, setDetails] = useState(initialData);

  const [html, setHtml] = useState(
    "Dear Sir/Madam,  </br> <br> <br> <br> Thanks & Regards, <br> " +
      user.userName,
  );
  // const [html, setHtml] = useState("");
  const [error, setError] = useState("");

  const onChange = (e) => {
    setHtml(e.target.value);
    if (e.target.value.trim() !== "") {
      setError(""); // clear error when user types
    }
    setDetails((prevState) => ({
      ...prevState,
      remark: e.target.value,
    }));
  };

  // useEffect(() => {
  //   if (!applyLeaveModal) {
  //     setDetails(initialData);
  //     setFromdate("");
  //     setToDate("");
  //     setDOR("");
  //   }
  // }, []);

  const fetchWeekendHolidaysList = (fromdate, todate, sHsts, eHsts) => {
    const payload = {
      fromdate: fromdate,
      todate: todate,
      sHsts: sHsts,
      eHsts: eHsts,
    };
    LeaveHistoryService.getWeekendHolidaysList(payload)
      .then((resp) => {
        // console.log(resp.data);
        setDetails((prevState) => ({
          ...prevState,
          duration: resp.data[0].workday,
        }));
      })
      .catch((e) => console.log(e));
  };

  const handleFromDateChange = (e) => {
    // console.log("From Date Changed:", e.value);
    setFromdate(e.value);
    const fDate = moment(new Date(e.value)).format("YYYY-MM-DD");
    setDetails((prevState) => ({
      ...prevState,
      fromDate: fDate,
      formatedFromDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
    fetchWeekendHolidaysList(
      fDate,
      details.toDate,
      details.fromDateSession,
      details.toDateSession,
    );
  };

  const handleToDateChange = (e) => {
    setToDate(e.value);
    const tdate = moment(new Date(e.value)).format("YYYY-MM-DD");
    setDetails((prevState) => ({
      ...prevState,
      toDate: tdate,
      formatedToDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
    fetchWeekendHolidaysList(
      details.fromDate,
      tdate,
      details.fromDateSession,
      details.toDateSession,
    );
  };

  const handleDORChange = (e) => {
    setDOR(e.value);
    const dor = moment(new Date(e.value)).format("YYYY-MM-DD");
    setDetails((prevState) => ({
      ...prevState,
      dor: dor,
      formatedDOR: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
  };

  const handleSelectLeaveCat = (e) => {
    setDetails((prevState) => ({
      ...prevState,
      leaveCategory: e.value,
      leaveReason: e.label,
    }));
  };

  const hideLeaveModal = (e) => {
    e.preventDefault();
    setApplyLeaveModal(false);
    clearData();
  };

  const handleSelect = (e, name) => {
    if (name === "fromDateSession") {
      setDetails((prevState) => ({
        ...prevState,
        fromDateSession: e.value,
      }));

      fetchWeekendHolidaysList(
        details.fromDate,
        details.toDate,
        e.value,
        details.toDateSession,
      );
    } else if (name === "toDateSession") {
      fetchWeekendHolidaysList(
        details.fromDate,
        details.toDate,
        details.fromDateSession,
        e.value,
      );

      setDetails((prevState) => ({
        ...prevState,
        toDateSession: e.value,
      }));
    }
  };

  const handleSelectCCList = (e) => {
    setCCList(e);
    const data = e.map((item) => item.value);

    setDetails((prev) => ({
      ...prev,
      ccList: data,
    }));
  };

  const clearData = () => {
    setFromdate(null);
    setToDate(null);
    setDetails(initialData);
    setHtml("");
    setError("");
  };

  const handleSubmitApply = () => {
    // console.log(details);

    // const payload = {
    //   emp_id: user && user.empid,
    //   catagoryId: details.leaveCategory,
    //   fromDate: details.fromDate,
    //   toDate: details.toDate,
    //   leavedays: details.duration,
    //   leaveReason: details.leaveReason,
    //   dor: details.dor,
    //   description: details.remark,
    //   FDatehalfday: details.fromDateSession,
    //   TDatehalfday: details.toDateSession,
    //   CCemail: details.ccList.toString()
    // };

    const payload = {
      employeeId: user && user.empid,
      catagoryId: details.leaveCategory,
      fromDate: details.fromDate,
      toDate: details.toDate,
      leavedays: details.duration,
      leaveReason: details.leaveReason,
      dor: details.dor,
      description: details.remark,
      FDatehalfday: details.fromDateSession,
      TDatehalfday: details.toDateSession,
      cCemail: details.ccList
    };

    // const parser = new DOMParser();
    // const doc = parser.parseFromString(html, "text/html");
    // const text = doc.body.textContent;
    // const textArr = text && text.split(",");

    // const start = "Dear Sir/Madam";
    // const end = "Thanks & Regards";

    // const startIndex = text.indexOf(start);
    // const endIndex = text.indexOf(end);

    setLoading(true);

    // const betweenText = text
    //   .substring(startIndex + start.length, endIndex)
    //   .trim();

    // console.log("betweenText", betweenText);

    if (
      details.fromDate !== "" &&
      details.toDate !== "" &&
      details.dor !== "" &&
      details.leaveReason !== ""
      // betweenText !== ","
    ) {
      LeaveHistoryService.applyleaveRequest(payload)
        .then((resp) => {
          if (resp.data) {
            setSuccess(true);
            setHeading("Leave Applied Successfully!");
            setApplyLeaveModal(false);
            fetchData();
            clearData();
            setLoading(false);
          }
        })
        .catch((e) => console.log(e));
    } else {
      toast.warn("*Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`${
          applyLeaveModal ? "applyLeaveModal visible" : "applyLeaveModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <ToastContainer />
            <div className="leaveModalHeading mb-lg-5 mb-4">
              <Flex
                className="mb-lg-5 mb-4"
                justify="space-between"
                align="center"
              >
                <Flex className="left-flex" gap={10} align="center">
                  <div className="heading">
                    <span>Applying for leave </span>
                  </div>
                </Flex>
                <div className="close">
                  <IoMdClose
                    size={30}
                    color="#4E465E"
                    onClick={() => setApplyLeaveModal(false)}
                  />
                </div>
              </Flex>

              <div className="row">
                <div className="col-lg-6">
                  <div className="left-flex">
                    <div className="profile">
                      {user && user.profile ? (
                        <img src={profileImg} width={40} alt="profileImg" />
                      ) : (
                        <>
                          {user.role === "1" ? (
                            <div className="circle">
                              <span>HR</span>
                            </div>
                          ) : (
                            <div className="circle">
                             <span>{getNameInitials(user && user.userName)}</span>
                            </div>
                          )}
                        </>
                      )}
                      <div className="profile-info">
                        <span className="name">{user && user.userName}</span>
                        <span className="desig">
                          {user && user.designation}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="balance">
                    <div className="left">
                      <span>Balance</span>
                    </div>
                    <div className="right">
                      {/* <div className="flex">
                        <span>Monthly:</span>
                        <span className="count">01</span>
                      </div> */}
                      <div className="flex">
                        <span>Quarterly:</span>
                        <span className="count">
                          {leaveInfo && leaveInfo.queterlyBalanceLeave}
                        </span>
                      </div>
                      <div className="flex">
                        <span>Yearly:</span>
                        <span className="count">
                          {leaveInfo && leaveInfo.yearlyBalanceLeave}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="leaveModalBody">
              <div className="row">
                <div className="col-lg-6 col-7">
                  <div className="mb-3 calendar-relative">
                    <label htmlFor="leaveType" className="form-label">
                      From Date *
                    </label>
                    <Calendar
                      value={fromDate}
                      onChange={handleFromDateChange}
                      view="date"
                      dateFormat="dd, M, yy"
                      style={{ width: "100%", height: "45px" }}
                      showIcon
                      // disabledDays={[0, 6]}
                      selectOtherMonths
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-5">
                  <div className="mb-3">
                    <label htmlFor="leaveType" className="form-label">
                      Session
                    </label>
                    <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,

                          height: "45px",
                          fontSize: "16px",
                          lineHeight: "20px",
                          fontWeight: "500",
                          border: "1px solid rgba(210, 205, 218, 1)",
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          fontSize: "16px",
                          lineHeight: "20px",
                          fontWeight: "500",
                          borderRadius: "4px",
                          backgroundColor: isSelected
                            ? "rgba(177, 206, 251, 1)"
                            : isFocused
                              ? "rgba(177, 206, 251, 1)"
                              : "rgba(255, 255, 255, 1)",
                          color: isSelected
                            ? "rgba(78, 70, 94, 1)"
                            : isFocused
                              ? "rgba(78, 70, 94, 1)"
                              : "rgba(78, 70, 94, 1)",
                        }),
                        menu: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: "rgba(255, 255, 255, 1)",
                          boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                        }),
                      }}
                      options={leaveSessions}
                      onChange={(e) => {
                        handleSelect(e, "fromDateSession");
                      }}
                      value={
                        Array.isArray(leaveSessions)
                          ? leaveSessions.filter((option) =>
                              details.fromDateSession.includes(option.value),
                            )
                          : []
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-7">
                  <div className="mb-3 calendar-relative">
                    <label htmlFor="leaveType" className="form-label">
                      To Date *
                    </label>
                    <Calendar
                      value={toDate}
                      onChange={handleToDateChange}
                      view="date"
                      dateFormat="dd, M, yy"
                      style={{ width: "100%", height: "45px" }}
                      showIcon
                      // disabledDays={[0, 6]}
                      selectOtherMonths
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-5">
                  <div className="mb-3">
                    <label htmlFor="leaveType" className="form-label">
                      Session
                    </label>
                    <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          height: "45px",
                          fontSize: "16px",
                          lineHeight: "20px",
                          fontWeight: "500",
                          border: "1px solid rgba(210, 205, 218, 1)",
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          fontSize: "16px",
                          lineHeight: "20px",
                          fontWeight: "500",
                          borderRadius: "4px",
                          backgroundColor: isSelected
                            ? "rgba(177, 206, 251, 1)"
                            : isFocused
                              ? "rgba(177, 206, 251, 1)"
                              : "rgba(255, 255, 255, 1)",
                          color: isSelected
                            ? "rgba(78, 70, 94, 1)"
                            : isFocused
                              ? "rgba(78, 70, 94, 1)"
                              : "rgba(78, 70, 94, 1)",
                        }),
                        menu: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: "rgba(255, 255, 255, 1)",
                          boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                        }),
                      }}
                      options={leaveSessions}
                      onChange={(e) => {
                        handleSelect(e, "toDateSession");
                      }}
                      value={
                        Array.isArray(leaveSessions)
                          ? leaveSessions.filter((option) =>
                              details.toDateSession.includes(option.value),
                            )
                          : []
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label
                      htmlFor="leaveType"
                      title={details.leaveReason}
                      className="form-label"
                    >
                      Leave Reason *
                    </label>
                    <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          height: "45px",
                          fontSize: "16px",
                          lineHeight: "20px",
                          fontWeight: "500",
                          border: "1px solid rgba(210, 205, 218, 1)",
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          fontSize: "16px",
                          lineHeight: "20px",
                          fontWeight: "500",
                          borderRadius: "4px",
                          backgroundColor: isSelected
                            ? "rgba(177, 206, 251, 1)"
                            : isFocused
                              ? "rgba(177, 206, 251, 1)"
                              : "rgba(255, 255, 255, 1)",
                          color: isSelected
                            ? "rgba(78, 70, 94, 1)"
                            : isFocused
                              ? "rgba(78, 70, 94, 1)"
                              : "rgba(78, 70, 94, 1)",
                        }),
                        menu: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: "rgba(255, 255, 255, 1)",
                          boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                        }),
                      }}
                      options={leaveCat}
                      onChange={handleSelectLeaveCat}
                      title={details.leaveReason}
                      value={
                        Array.isArray(leaveCat)
                          ? leaveCat.filter(
                              (option) => option.label === details.leaveReason,
                            )
                          : null
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 calendar-relative">
                    <label htmlFor="leaveType" className="form-label">
                      Date Of Return *
                    </label>
                    <Calendar
                      value={dor}
                      onChange={handleDORChange}
                      view="date"
                      dateFormat="dd, MM, yy"
                      style={{ width: "100%", height: "45px" }}
                      showIcon
                      // disabledDays={[0, 6]}
                      selectOtherMonths
                    />
                  </div>
                </div>
              </div>
              <div className="right-flex">
                <span>Applying For: </span>
                <span className="dayscount">{details.duration} Days</span>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label htmlFor="leaveType" className="form-label mb-3">
                      Approval Hierarchy
                    </label>
                    <div className="approval-list">
                      <div className="item">
                        <div className="icon profile">
                          {approvalHierarchy[0].profile &&
                          approvalHierarchy[0].profile ? (
                            <img src={profileImg} width={40} alt="profileImg" />
                          ) : (
                            <>
                              <div className="circle">
                                 <span>{getNameInitials(approvalHierarchy && approvalHierarchy[0].name)}</span>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="info">
                          <span className="name">
                            {approvalHierarchy[0].name}
                          </span>
                          <span className="code">
                            #{approvalHierarchy[0].empid}
                          </span>
                          <span className="desig">RM</span>
                        </div>
                      </div>

                      {user.role !== "1" && (
                        <>
                          <div className="item">
                            <div className="icon profile">
                              {approvalHierarchy[1].profile &&
                              approvalHierarchy[1].profile ? (
                                <img
                                  src={profileImg}
                                  width={40}
                                  alt="profileImg"
                                />
                              ) : (
                                <>
                                  <div className="circle">
                                    <span>{getNameInitials(approvalHierarchy && approvalHierarchy[1].name)}</span>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="info">
                              <span className="name">
                                {approvalHierarchy[1].name}
                              </span>
                              <span className="code">
                                #{approvalHierarchy[1].empid}
                              </span>
                              <span className="desig">HR</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-3">
                    <Flex className="mb-3" justify="space-between" align="center">
                      <label htmlFor="leaveType" className="form-label mb-3">
                        Add CC
                      </label>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            height: "45px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            fontWeight: "500",
                            border: "1px solid rgba(210, 205, 218, 1)",
                          }),
                          option: (baseStyles, { isFocused, isSelected }) => ({
                            ...baseStyles,
                            fontSize: "16px",
                            lineHeight: "20px",
                            fontWeight: "500",
                            borderRadius: "4px",
                            backgroundColor: isSelected
                              ? "rgba(177, 206, 251, 1)"
                              : isFocused
                                ? "rgba(177, 206, 251, 1)"
                                : "rgba(255, 255, 255, 1)",
                            color: isSelected
                              ? "rgba(78, 70, 94, 1)"
                              : isFocused
                                ? "rgba(78, 70, 94, 1)"
                                : "rgba(78, 70, 94, 1)",
                          }),
                          menu: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                          }),
                        }}
                        options={empList}
                        isMulti={true}
                        onChange={handleSelectCCList}
                        value={ccList}
                        // value={
                        //   Array.isArray(empList)
                        //     ? empList.filter((option) =>
                        //         details.ccList.includes(option.value),
                        //       )
                        //     : []
                        // }
                      />
                     
                    </Flex>
                    <div className="approval-list">
                      {Array.isArray(ccList)
                        ? ccList.map((item) => {
                            return (
                              <>
                                <div className="item">
                                  <div className="icon profile">
                                    {ccList.profile && ccList.profile ? (
                                      <img
                                        src={profileImg}
                                        width={40}
                                        alt="profileImg"
                                      />
                                    ) : (
                                      <>
                                        <div className="circle">
                                          <span>{getNameInitials(item.label && item.label)}</span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="info">
                                    <span className="name">{item.label}</span>
                                    <span className="code">#{item.value}</span>
                                  </div>
                                </div>
                              </>
                            );
                          })
                        : null}

                     
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label htmlFor="leaveType" className="form-label mb-3">
                      Description *
                    </label>
                    <Editor value={html} onChange={onChange} />
                  </div>
                  {error && (
                    <div style={{ color: "red", marginTop: "5px" }}>
                      {error}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={hideLeaveModal}>
              Cancel
            </button>
            <button
              className="btn btn-apply"
              type="button"
              onClick={handleSubmitApply}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Apply"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplyLeave;
